/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Redaction_SectionInputs */



/**
* | output |
* | --- |
* | "Redacted Patterns" |
*
* @param {Audit_Details_Redaction_SectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_redaction_section = /** @type {((inputs?: Audit_Details_Redaction_SectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Redaction_SectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Redigierte Muster")
	return /** @type {LocalizedString} */ ("Redacted Patterns")
});